export const getUserDetails = state => state.user



// WEBPACK FOOTER //
// ./client/store/modules/user/getters.js